import { render, staticRenderFns } from "./MypageOneTimePassConfirmPage.vue?vue&type=template&id=939f152e"
import script from "./MypageOneTimePassConfirmPage.vue?vue&type=script&lang=ts"
export * from "./MypageOneTimePassConfirmPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports